import validate from "/Users/yuto.yasuoka/Project/chirashi-viewer/node_modules/nuxt/dist/pages/runtime/validate.js";
import index_45global from "/Users/yuto.yasuoka/Project/chirashi-viewer/middleware/index.global.js";
import manifest_45route_45rule from "/Users/yuto.yasuoka/Project/chirashi-viewer/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  index_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}